import { observable, action } from 'mobx'

class Window {
  @observable width = window.innerWidth
  @observable height = window.innerHeight
  @observable selectMode = false
  @observable selectInProcess = false
  @observable showPopover = false
  @observable disableSwiper = false

  constructor () {
    window.addEventListener('resize', () => {
      this.width = window.innerWidth
      this.height = window.innerHeight
    })
  }

  @action
  updateViewportHeight = () => {
    if (window.innerHeight !== this.height) {
      this.height = window.innerHeight
    }
  }
}

class Menu {
  @observable open = false
  @observable language = 'de'
  @observable showProgressBar = true
  @observable showYellowProgress = true
  @observable notizenOpen = false
}

class CurrentStory {
  @observable id: string | null = null
  @observable position: number = 0
  @observable scrollerData: number[] = []
  @observable paused = false
  @observable play = false
}

export class CommonStore {
  menu: Menu
  window: Window
  currentStory: CurrentStory

  constructor () {
    this.menu = new Menu()
    this.window = new Window()
    this.currentStory = new CurrentStory()
  }
}
